<template lang="pug">
#modal-validacao-territorio
    el-dialog.modal-argentina-notificacao.modal-argentina-notificacao(
        :visible.sync='show',
        :before-close='closeDialog',
        title='Notificaión de denegación de registro',
        :close-on-click-modal='false'
    )
        .body
            h1.titulo {{ $t('mensagens.territorio.territorioArgentina.motivoReprovacao') }}
            textarea(
                placeholder='Escriba la justificación',
                v-model='mensagem'
            )
        .footer
            el-button(type='secondary', @click='closeDialog') {{ $t('mensagens.territorio.territorioArgentina.fecharModal') }}
            el-button(type='primary', @click='reprovarTerritorio') {{ $t('mensagens.territorio.territorioArgentina.reprovarContrato') }}
</template>

<script>
export default {
    name: 'ModalNotificacaoAR',
    components: {},
    props: {
        show: {
            type: Boolean,
            required: true
        },
        idTerritorio: {
            type: Number,
            required: false
        }
    },
    data() {
        return {
            mensagem: ''
        };
    },
    emits: ['close'],
    methods: {
        closeDialog() {
            this.$emit('close');
        },
        async reprovarTerritorio() {
            try {
                await this.$emit('reprovar', this.mensagem, this.idTerritorio);
                await this.$emit('close');
            } catch (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            }
        }
    }
};
</script>

<style lang="scss">
.modal-argentina-notificacao {
    .el-dialog {
        .el-dialog__body {
            padding: 0 !important;
            display: flex;
            flex-direction: column;
            .body {
                padding: 10px 20px;
                display: flex;
                flex-direction: column;
                gap: 5px;
                .titulo {
                    font-weight: 400;
                    font-family: Roboto;
                    color: #3b3b3b;
                }
                textarea {
                    box-shadow: 0 0 0 0;
                    border: 1px solid #e0e0e0;
                    outline: 0;
                    border-radius: 5px;
                    padding: 8px;
                    height: 150px;
                    color: #7c7c7c;
                    font-family: Roboto;
                    font-weight: 400;
                    font-size: 14px;
                    &::placeholder {
                        color: #7c7c7c;
                        font-family: Roboto;
                        font-weight: 400;
                        font-size: 14px;
                    }
                }
            }
            .footer {
                margin-top: 10px;
                border-top: 1px solid #e0e0e0;
                padding: 8px 15px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }
        }
    }
}
</style>
